import BooleanCellBadge from "./BooleanCellBadge";

import { cn } from "@/lib/utils";

interface TruthyCellPreviewProps {
  value: boolean;
  label: string;
  className?: string;
}

export default function TruthyCellPreview({ value, label, className }: TruthyCellPreviewProps) {
  return (
    <span
      className={cn("flex h-full w-full min-w-0 flex-1 items-center justify-center", className)}
      title={label}
    >
      <BooleanCellBadge value={value} />
    </span>
  );
}
